import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import Section from '../../components/Section';
import SectionHeader from '../../components/SectionHeader';
import SectionBody from '../../components/SectionBody';

import { ReactComponent as Icon } from '../../assets/icons/eSign.svg';
import Image from '../../assets/icons/eSign_grey.svg';

const useStyles = makeStyles(() => ({
    content: {
        fontFamily: 'SourceSansPro-Regular',
        fontSize: 16,
        marginBottom: 20
    },
    links: {
        fontFamily: 'SourceSansPro-SemiBold',
    },
    listItem: {
        marginBottom: 20,
    },
    link: {
        color: '#ed1c24 !important',
        textDecoration: 'none !important',
        cursor: 'pointer !important',
        marginLeft: '20 !important',
        fontFamily: 'SourceSansPro-SemiBold'
    }
}));

const ESignComponent = ({ setPage }) => {
    const classes = useStyles();

    return (
        <Section backgroundImage={Image}>
            <SectionHeader title="eSign">
                <Icon width={40} height={40} />
            </SectionHeader>
            <SectionBody>

                <div>
                    <ul className={classes.list}>
                        <li className={classes.listItem}>
                            <a href="https://docs.esign.celfocus.com/esignmain/main/installation/index.html" className="linkText" underline='none'>Setup Environment</a>
                        </li>
                        <li className={classes.listItem}>
                            <Link
                                className="linkText"
                                to={"/documentation/esign"}
                                underline='none'
                                rel='noopener noreferrer'>
                                Documentation
                            </Link>
                        </li>
                        <li className={classes.listItem}>
                            <Link
                                className="linkText"
                                to={"/releaseversion/esign"}
                                underline='none'
                                rel='noopener noreferrer'>Releases & Changelog</Link>
                        </li>
                        <li className={classes.listItem}>
                            <Link
                                to={{ pathname: process.env.REACT_APP_GET_SUPPORT_ESIGN_URL }}
                                className="linkText"
                                underline='none'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Support
                            </Link>
                        </li>
                        <li className={classes.listItem}>
                            <Link
                                to={{ pathname: process.env.REACT_APP_FEEDBACK_ESIGN_URL }}
                                className="linkText"
                                underline='none'
                                target='_blank'
                                rel='noopener noreferrer'>
                                Roadmap
                            </Link>
                        </li>
                    </ul>

                </div>
            </SectionBody>
        </Section>

    );

}

export default ESignComponent;
